import { Injectable } from '@angular/core';
import { CanLoad, CanActivate, Router} from '@angular/router';
import { AuthService } from './auth.service';
import { AppConstants } from './config.service';
@Injectable()
export class AuthUsersGuard implements CanActivate {
  constructor(private appConstants : AppConstants,private router : Router,private authService : AuthService) { };
  async canActivate() {
    await this.appConstants.getTenantUserId()
    const isTenantUserIdAvailable = this.appConstants.tenantUserId && this.appConstants.tenantUserId.length ? true : false;
    const isRoleAvailable = await this.authService.checkRoleExist('trutesta-accreditation');
    let userStatus = !isTenantUserIdAvailable || !isRoleAvailable ? false : true;
    if(!userStatus)
    this.router.navigate(['/authorized'])
    return userStatus
  }
}